import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress } from '@material-ui/core';
import { ArrowBackIos, ArrowForwardIos } from '@material-ui/icons';
import { useNavigate } from 'react-router-dom';
const MedicalView = ({ student, isLoading, setCurrentState, isAdmin, token, isPortedLayout = false }) => {
	const navigate = useNavigate();
	const goToEditMedications = () => {
		if (isAdmin) {
			navigate({ pathname: '/students-editmedications', state: { student, tab: 'medication', isPortedLayout } });
		} else {
			navigate({ pathname: '/medications', state: { student, token, tab: 'medication', isPortedLayout } });
		}
	};

	const handleNext = () => {
		setCurrentState('room-attachments');
	};
	return (
		<>
			<div className="flex items-center flex-nowrap justify-between mx-auto mb-10">
				<span className="md:text-pd-lg lg:text-pd-xl self-end font-extrabold">Medical</span>
				<div className="personal-button flex justify-between">
					<span className="mx-4">
						<CustomButton
							disabled={isLoading}
							fontSize="15px"
							height="46"
							onClick={goToEditMedications}
							variant="secondary"
							width="100px"
						>
							<FontAwesomeIcon icon={faEdit} />
							<span> Edit </span>
						</CustomButton>
					</span>
				</div>
			</div>
			<div className="per-detail bg-white mx-auto">
				{isLoading ? (
					<div className="flex align-center justify-center">
						<CircularProgress size={35} />
					</div>
				) : (
					<>
						<div className="grid grid-cols-2 md:grid-cols-3 gap-y-32">
							<div className="flex flex-col items-start medical-info-1 col-span-2 sm:col-span-1">
								<div>Allergies</div>
								<div className="md:text-pd-lg lg:text-pd-lg font-bold">
									{student?.allergies || `${student?.first_name} ${student?.last_name} has no allergies`}
								</div>
							</div>
							<div className="flex flex-col items-start medical-info-2">
								<div>Doctor</div>
								<div className="md:text-pd-lg lg:text-pd-lg font-bold">
									{student?.doctor?.name || `${student?.first_name} ${student?.last_name} has no Doctor on record`}
								</div>
							</div>
							<div className="flex flex-col items-start medical-info-1">
								<div>Medical Condition</div>
								<div className="md:text-pd-lg lg:text-pd-lg font-bold">
									{student?.is_medical_condition === 1
										? 'Yes'
										: `${student?.first_name} ${student?.last_name} has no medical condition on record`}
								</div>
							</div>
						</div>
						<div className="flex">
							<div className="flex flex-col items-start mt-32">
								<div>Description</div>
								<div className="md:text-pd-lg lg:text-pd-lg font-bold">
									{student?.is_medical_condition ? student.description || 'N/A' : 'N/A'}
								</div>
							</div>
						</div>
						<hr className="mt-32" style={{ color: 'lightgrey' }} />
						<div style={{ overflowX: 'auto' }}>
							<table className="mt-20 w-full">
								<thead className="bg-blue-100">
									<tr>
										<td
											className="size-head font-bold py-16 pl-16 med-table-headers text-left"
											style={{ minWidth: 50 }}
										>
											Medication
										</td>
										<td className="size-head font-bold py-16 med-table-headers text-left" style={{ minWidth: 50 }}>
											Frequency
										</td>
										<td className="size-head font-bold py-16 med-table-headers text-left" style={{ minWidth: 50 }}>
											Start Date
										</td>
										<td className="size-head font-bold py-16 med-table-headers text-left" style={{ minWidth: 50 }}>
											End Date
										</td>
									</tr>
								</thead>
								<tbody>
									{student?.is_medical_condition === 1 ? (
										student?.medications.length ? (
											student?.medications.map((medication) => {
												return <MedicationItem key={medication.id} medication={medication} />;
											})
										) : (
											<tr>
												<td colSpan={4}>
													<div className="flex justify-center mt-20 font-bold text-pd-lg text-size-head">
														No Medication
													</div>
												</td>
											</tr>
										)
									) : (
										<tr>
											<td colSpan={4}>
												<div className="flex justify-center mt-20 font-bold text-pd-lg text-size-head">
													No Medical Condition
												</div>
											</td>
										</tr>
									)}
								</tbody>
							</table>
						</div>
					</>
				)}
			</div>
			{!isPortedLayout ? (
				<div className="w-full flex justify-between mt-20 mb-80 pb-80 lg:mb-64 lg:pb-64">
					<CustomButton
						fontSize="15px"
						height="46"
						onClick={() => {
							setCurrentState('personal');
						}}
						variant="primary"
						width="120px"
					>
						<div className="flex items-center justify-center">
							<ArrowBackIos className="" style={{ fontSize: '1.6rem' }} />
							Previous
						</div>
					</CustomButton>
					<CustomButton
						disabled={isLoading}
						fontSize="15px"
						height="46"
						onClick={handleNext}
						variant="primary"
						width="100px"
					>
						<div className="flex items-center justify-center ml-6">
							Next
							<ArrowForwardIos className="ml-6" style={{ fontSize: '1.6rem' }} />
						</div>
					</CustomButton>
				</div>
			) : null}
		</>
	);
};

const MedicationItem = ({ medication }) => {
	return (
		<>
			<tr className="border-b">
				<td className="py-16 pl-16">{medication.name}</td>
				<td className="py-16">{medication.frequency}</td>
				<td className="py-16">{medication.start_date}</td>
				<td className="py-16">{medication.end_date}</td>
			</tr>
			{/* <hr className="" style={{ color: 'lightgrey' }} /> */}
		</>
	);
};

export default MedicalView;
